import React, { useState } from "react";
import Collapsible from "react-collapsible";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import { useSelector } from "react-redux";

export default function MainGroup({ group, children }) {
  const [open, setOpen] = useState(!group.collapsed_by_default);
  const language = useSelector((state) => state.store.language);

  return (
    <div className="mt-2 mb-4">
      <Collapsible
        triggerDisabled={!group.collapsible}
        open={open}
        handleTriggerClick={(e) => {
          setOpen(!open);
        }}
        trigger={
          <p
            style={{
              fontWeight: "bold",
              backgroundColor: !open && "white",
              fontSize: 18,
              direction: language === "arabic" && "rtl",
              display: "flex",
              alignItems: "center",
              transition: "0.4s linear",
              justifyContent: "space-between",
              marginBottom: "-5px",
            }}
            className="p-3"
          >
            <div>{(language === "arabic" && group.ar_name) || group.name}</div>

            <div>
              {group.collapsible && (
                <ArrowDropDownIcon
                  style={{
                    marginLeft: language == "english" && "auto",
                    marginRight: language == "arabic" && "auto",
                    fontSize: 30,
                  }}
                />
              )}
            </div>
          </p>
        }
      >
        {children}
      </Collapsible>
    </div>
  );
}
